/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';
import imagesLoaded from 'imagesloaded';

// Equal height cells hack (from Flickity maintainer)
Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};
Flickity.createMethods.push('_createResizeClass');
var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call(this);
  this.element.classList.add('flickity-resize');
};

export function brandsSlider() {
  var slider = document.querySelector('.homeBrands__panels');
  if (!slider) return;

  var flkty = new Flickity(slider, {
    cellAlign: 'center',
    cellSelector: '.homeBrands__panel',
    contain: false,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    adaptiveHeight: false,
    autoPlay: 5000,
    pauseAutoPlayOnHover: true,
    on: {
      ready: function () {
        setTimeout(function () {
          flkty.resize();
        }, 1000);
      }
    }
  });

  // Init runs before the panel images finish loading, so re-measure once
  // they arrive. Scoped to the slider element only: waiting on the whole
  // body meant a hung tracking pixel blocked the carousel entirely.
  imagesLoaded(slider, function () {
    flkty.resize();
  });

  // Custom prev/next buttons
  var prevBtn = document.querySelector('.homeBrands__prev');
  if (prevBtn) {
    prevBtn.addEventListener('mouseenter', function () { flkty.stopPlayer(); });
    prevBtn.addEventListener('click', function () {
      flkty.previous(true);
    });
  }

  var nextBtn = document.querySelector('.homeBrands__next');
  if (nextBtn) {
    nextBtn.addEventListener('mouseenter', function () { flkty.stopPlayer(); });
    nextBtn.addEventListener('click', function () {
      flkty.next(true);
    });
  }
}

